<template>
  <div v-if="headerMessage" class="environment-header-placeholder">
    <div v-if="headerMessage" class="environment-header" :style="{ backgroundColor: headerMessage.color }">
      {{ headerMessage.message }}
    </div>
  </div>
</template>

<script lang="ts" src="./dl-version-header.ts"></script>

<style lang="scss" scoped src="./dl-version-header.scss"></style>
